import { useTranslation } from "react-i18next";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
import UserTypeBadge from "../badges/UserTypeBadge";

export type ContactCardProps = {
  full_name: string;
  profile_picture_url?: string;
  first_name?: string;
  last_name?: string;
  object_type: "liaison" | "student" | "tutor" | "candidate";
  addConversationParticipant?: (
    participantId: number | string,
    participantType: "student" | "candidate" | "liaison" | "tutor"
  ) => void;
  id: number | string;
};
export default function ContactCard(props: ContactCardProps) {
  const {
    full_name: name,
    first_name: firstName,
    last_name: lastName,
    profile_picture_url: avatar,
    object_type: userType,
    addConversationParticipant,
    id,
  } = props;
  const { t } = useTranslation("", {
    keyPrefix: "userType",
  });
  return (
    <div
      className="px-2 py-6 flex items-center border-b border-gray-200 cursor-pointer"
      onClick={() =>
        addConversationParticipant && addConversationParticipant(id, userType)
      }
    >
      <UserProfilePictureAvatar
        profilePictureUrl={avatar}
        className="w-10 h-10 flex-shrink-0"
        alt={userType}
      />
      <p className="w-full text-base font-medium text-gray-500 rtl:pr-2 rtl:pl-0.5 ltr:pl-2 ltr:pr-0.5">
        {userType?.toLowerCase() === "supervisor"
          ? t("supervisor")
          : `${firstName} ${lastName}`}
      </p>
      <UserTypeBadge
        userType={
          userType?.toLowerCase() as
            | "liaison"
            | "student"
            | "tutor"
            | "candidate"
            | "supervisor"
        }
      />
    </div>
  );
}
